// Seasonal data configuration for Ireland
// Irish seasons: Winter (Nov, Dec, Jan), Spring (Feb, Mar, Apr), Summer (May, Jun, Jul), Autumn (Aug, Sep, Oct)

export const SEASONS = {
  winter: {
    id: 'winter',
    label: 'Winter',
    months: ['nov', 'dec', 'jan']
  },
  spring: {
    id: 'spring',
    label: 'Spring',
    months: ['feb', 'mar', 'apr']
  },
  summer: {
    id: 'summer',
    label: 'Summer',
    months: ['may', 'jun', 'jul']
  },
  autumn: {
    id: 'autumn',
    label: 'Autumn',
    months: ['aug', 'sep', 'oct']
  }
}

export const MONTHS = {
  jan: { id: 'jan', label: 'January', short: 'Jan', season: 'winter', order: 1 },
  feb: { id: 'feb', label: 'February', short: 'Feb', season: 'spring', order: 2 },
  mar: { id: 'mar', label: 'March', short: 'Mar', season: 'spring', order: 3 },
  apr: { id: 'apr', label: 'April', short: 'Apr', season: 'spring', order: 4 },
  may: { id: 'may', label: 'May', short: 'May', season: 'summer', order: 5 },
  jun: { id: 'jun', label: 'June', short: 'Jun', season: 'summer', order: 6 },
  jul: { id: 'jul', label: 'July', short: 'Jul', season: 'summer', order: 7 },
  aug: { id: 'aug', label: 'August', short: 'Aug', season: 'autumn', order: 8 },
  sep: { id: 'sep', label: 'September', short: 'Sep', season: 'autumn', order: 9 },
  oct: { id: 'oct', label: 'October', short: 'Oct', season: 'autumn', order: 10 },
  nov: { id: 'nov', label: 'November', short: 'Nov', season: 'winter', order: 11 },
  dec: { id: 'dec', label: 'December', short: 'Dec', season: 'winter', order: 12 }
}

// Get months grouped by Irish seasons (for UI display)
export function getMonthsBySeason() {
  return [
    {
      ...SEASONS.winter,
      monthData: SEASONS.winter.months.map(m => MONTHS[m])
    },
    {
      ...SEASONS.spring,
      monthData: SEASONS.spring.months.map(m => MONTHS[m])
    },
    {
      ...SEASONS.summer,
      monthData: SEASONS.summer.months.map(m => MONTHS[m])
    },
    {
      ...SEASONS.autumn,
      monthData: SEASONS.autumn.months.map(m => MONTHS[m])
    }
  ]
}

export default {
  SEASONS,
  MONTHS,
  getMonthsBySeason
}
